var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-right",
    clipPath: "url(#clip0_3628_14970)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.71484 2.07255L1.28627 8.50112L7.71484 14.9297",
    stroke: "#3D3D3D",
    strokeWidth: 2.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3628_14970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 15.4286,
    fill: "white",
    transform: "matrix(-1 0 0 -1 9 16.2148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight1);
export default __webpack_public_path__ + "static/media/chevronRight1.7e842fa933f237ed57fbe86f655ba3bc.svg";
export { ForwardRef as ReactComponent };